<template>
  <div id="home_container" class="outer-wrapper height-s-fix">
    <Transition name="image-cover">
      <img src="@/assets/images/header.jpg" v-if="isGifLoading && !isMobile" alt="" class="img-fluid m-0 image-cover">
    </Transition>
    <div class="row mx-0 position-absolute">
      <div class="ct-col col-lg-8 p-0 ">
        <div class="col-md-12">
          <Transition name="brand-logo" appear>
            <div class="brand-logo-mob text-left" v-if="!isMobile || (!isGifLoading && isMobile)">
              <img src="@/assets/images/nr-logo.png" width="100px" height="100px" alt="" class="img-fluid">
            </div>
          </Transition>
        </div>
      </div>
    </div>
    <div class="row h-100 no-gutters">
      <div class="col-12">
      <div class="h-100 no-gutters row ">
        <div class="col-12 banner-image image1">
            <!-- <div class="wing-name">
              Wing - C2
            </div> -->
        </div>
      </div>
    </div>
    <router-link to="/inventory" class="btn btn-proceed" >
      Proceed &nbsp;
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6673 15L10.5007 13.7917L13.459 10.8333H3.33398V9.16667H13.459L10.5007 6.20833L11.6673 5L16.6673 10L11.6673 15Z" fill="#0499B7"/>
      </svg>
    </router-link>
    </div>
  </div>
</template>

<script>
import {
  masterJson,
  userTypeUrl
} from '@/assets/scripts/utility.js';
import {
  FormSteps
} from '@/assets/scripts/utility.js';
export default {
  data() {
    return {
      formSteps: FormSteps,
      prevLabel: "",
      show: false,
      nextLabel: "",
      isDownVisible: true,
      isNewCustomer: true,

    }
  },
  computed: {
    masterBuildings() {
      return masterJson.Buildings;
    },
    slideImages() {
      return masterJson.Buildings.filter(building => building.image && building.status === "Available");
    },
    isLoading() {
      return this.$store.getters.isLoading
    },
    isGifLoading() {
      return this.$store.getters.isGifLoading;
    },
    isMobile() {
      return window && window.innerWidth <= 991;
    }
  },
  watch: {
    isGifLoading(newValue) {
      if (!newValue) {
        this.$refs && this.$refs.carousel && this.$refs.carousel.$forceUpdate();
      }
    }
  },
  methods: {
    toggleNav() {
      $('#navbarSupportedContent').toggle();
    },
    scrollToSection(e) {
      e.preventDefault();
      let targetsection = (e.target.getAttribute("href")).slice(1);
      let el = document.getElementById(targetsection);
      this.$refs[targetsection].scrollIntoView({
        behavior: "smooth"
      })
      $('#navbarSupportedContent').toggle();
    },
    downloadBrocher() {
      window.open('https://s3.ap-south-1.amazonaws.com/enrichr.public.images/shubham-artesia/shubham-artesia-brochure.pdf')
    },
    navigate() {
      this.$store.dispatch('setLoading', true);
    },
    getUserType() {
      if (this.$route.query.user) {
        let userId = this.$route.query.user;
        userId = atob(userId);
        this.$axios.get(userTypeUrl + '?user_id=' + userId).then((res) => {
          if (res.data.user_type === 'EndUser') {
            this.isNewCustomer = false;
          }
        });
      }
    }
  },
  created() {
    // let userId = this.$route.query.user_id;
    // if (userId) {
    //   userId = btoa(userId);
    //   this.$router.replace({
    //     query: {
    //       user: userId
    //     }
    //   });
    //   this.$store.dispatch('setUserId', userId);
    //   this.$cookies.set('nr-user-id', userId, '1d');
    // } else if (this.$route.query.user) {
    //   this.$store.dispatch('setUserId', this.$route.query.user);
    // } else {
    //   const storedId = this.$cookies.get('nr-user-id');
    //   if (storedId) {
    //     this.$store.dispatch('setUserId', storedId);
    //   } else {
    //     this.$store.dispatch('setUserId', null);
    //   }
    // }
  },
  mounted() {
    this.getUserType();
    // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    //     anchor.addEventListener('click', function (e) {
    //         e.preventDefault();
    //         $('html, body').animate({
    //             scrollTop: $($.attr(this, 'href')).offset().top - 100 
    //         }, 300);
    //     }, {passive: true});
    // });
    // Initialize default plot selection for next screen
    // let buildings = Object.assign({}, ...this.masterBuildings.filter(f => f.key === 'Plot 67'))
    // this.$store.dispatch("setTypology", buildings);
  }
}
</script>

<style scoped>
.img-width {
  width: 148px;
  height: 137px;
}
.btn-proceed{
  position: absolute;
  left: 50%;
  bottom: 16px;
  z-index: 10;
  background-color: #fff;
  border-radius: 100px;
  padding: 16px 100px;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.16px;
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;
}

.height-s-fix{
  height: 100vh;
  height: 100svh;
  width: 100vw;
}

.wing-name{
  font-size: 24px;
  font-weight: 800;
  line-height: 30.24px;
  text-align: center;
  padding: 30px;
  width: 100%;
  max-width: 421px;
  margin: 0 auto;
  margin-top: 200px;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIxIiBoZWlnaHQ9Ijg4IiB2aWV3Qm94PSIwIDAgNDIxIDg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjQ1IDBIOTEuODQ2NUM4Ny45ODEgMCA4NC40NjU2IDIuMjI5MDIgODIuNzA5OCA1LjY3MjgxQzgwLjI1NjggMTAuNDg0MiA3Ni41ODY4IDE3LjMyOTEgNzMuMzIyNiAyMkM2Ni40NDE1IDMxLjg0NjQgNTMgNDQgNTMgNDRDNTMgNDQgNjYuNDQxNSA1Ni4xNTM2IDczLjMyMjYgNjZDNzYuNTg2OCA3MC42NzA5IDgwLjI1NjggNzcuNTE1OCA4Mi43MDk4IDgyLjMyNzJDODQuNDY1NiA4NS43NzEgODcuOTgxIDg4IDkxLjg0NjUgODhIMjQ1TDI0NSA2NkwyNDUgNDRMMjQ1IDIyVjBaIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iMiIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNjAgNDMpIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzYyOV8zNTkwKSIvPgo8cGF0aCBkPSJNMTc2IDBIMzI5LjE1NEMzMzMuMDE5IDAgMzM2LjUzNCAyLjIyOTAyIDMzOC4yOSA1LjY3MjgxQzM0MC43NDMgMTAuNDg0MiAzNDQuNDEzIDE3LjMyOTEgMzQ3LjY3NyAyMkMzNTQuNTU4IDMxLjg0NjQgMzY4IDQ0IDM2OCA0NEMzNjggNDQgMzU0LjU1OCA1Ni4xNTM2IDM0Ny42NzcgNjZDMzQ0LjQxMyA3MC42NzA5IDM0MC43NDMgNzcuNTE1OCAzMzguMjkgODIuMzI3MkMzMzYuNTM0IDg1Ljc3MSAzMzMuMDE5IDg4IDMyOS4xNTQgODhIMTc2TDE3NiA2NkwxNzYgNDRMMTc2IDIyVjBaIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSIzNjEiIHk9IjQzIiB3aWR0aD0iNjAiIGhlaWdodD0iMiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzM2MjlfMzU5MCkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zNjI5XzM1OTAiIHgxPSIwIiB5MT0iMSIgeDI9IjYwIiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMjE1IiBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzM2MjlfMzU5MCIgeDE9IjM2MSIgeTE9IjQ0IiB4Mj0iNDIxIiB5Mj0iNDQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjIxNSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain
}

.banner-image{
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}

.brand-logo-mob {
  display: block;
    position: fixed;
    top: 0;
    z-index: 1033;
}

.image1{
  background-image: url(../assets/images/elavation.png);
  background-position: center;
}



.image-cover {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 1031;
}

.image-cover-leave-from {
  opacity: 1;
}

.image-cover-leave-active {
  transition: opacity 0.5s ease-out 0.5s;
}

.image-cover-leave-to {
  opacity: 0;
}



</style>
